import { render, staticRenderFns } from "./LogisticsDepartmentOverview.vue?vue&type=template&id=aef4808a&scoped=true&"
import script from "./LogisticsDepartmentOverview.vue?vue&type=script&lang=js&"
export * from "./LogisticsDepartmentOverview.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDepartmentOverview.vue?vue&type=style&index=0&id=aef4808a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef4808a",
  null
  
)

export default component.exports